import { useFileLoaded } from "@/app/hooks/useFileLoad";
import { ScrollAction, ScrollFrom } from "@/app/hooks/useReadScrollToBottom";
import { Message, RiskStatus } from "@/app/store/types";
import { sleep } from "@/app/utils/async";
import { isMobileDevice } from "@/app/utils/device";
import { parseFileData } from "@/app/utils/file";
import { useEffect, useRef } from "react";
import Locale from "@/app/locales";

export default function Video({ msg }: { msg: Message }) {
  const { onload, onError } = useFileLoaded(msg);
  const videoRef = useRef<HTMLVideoElement>(null);
  const content = msg.content as string;

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.addEventListener("canplaythrough", async () => {
        // 视频已完全加载，可以流畅播放
        if (msg.isNewMsg) {
          await sleep(100);
          msg.handleScrollToBottom?.(
            ScrollAction.FORCE_TO_BOTTOM,
            ScrollFrom.FILE_LOADED,
          );
        }
      });
    }
  }, []);

  if (msg.riskStatus === RiskStatus.Failed) {
    return <div>{Locale.riskMsg.forbidden}</div>;
  }

  // 使用原生video元素替代VideoPlayer
  return (
    <div>
      <video
        onError={onError}
        ref={videoRef}
        src={parseFileData(content)?.fileUrl}
        width={isMobileDevice() ? "100%" : 400}
        controls
        controlsList="play time volume fullscreen"
        className="w-full"
        onLoad={onload}
      />
    </div>
  );
}
